import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchAllNews } from "../../services/newsPublic";
import { sortNewsByDate } from "../../utils/newsUtils";
import "./newsBlock.css";

export default function NewsBlock() {
  const [latestNews, setLatestNews] = useState([]);

  useEffect(() => {
    fetchAllNews()
      .then((news) => {
        const sorted = sortNewsByDate(news, "newest").slice(0, 6);
        setLatestNews(sorted);
      })
      .catch(() => setLatestNews([]));
  }, []);

  return (
    <div className="container">
      <div className="newsContent">
        <div className="newsTitleBox">
          <h3 className="title">Пресс-центр</h3>
          <Link to="/all-news" className="btn btnNews">
            Все новости
          </Link>
        </div>
        <div className="newsBlock">
          {latestNews.map((news) => (
            <Link
              key={news.id}
              to={`/news/${news.id}`}
              className="news-preview-item"
            >
              {news.imagePreview && (
                <img src={news.imagePreview} alt={news.title} />
              )}
              <div className="newsText">
                <p>
                  {news.date} <span>{news.tegs}</span>
                </p>
                <h5>{news.title}</h5>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
